import React from 'react'
import PropTypes from 'prop-types'
import FeatureContainer from './FeatureContainer'
import ReactPlaceholder from 'react-placeholder'
import FeaturePlaceholder from './FeaturePlaceholder'

const Feature = ({
  isLoading,
  isVoucher,
  features,
  featuresSkusByCurrentSku,
  changeSku,
  SkuByType
}) => (
  <ReactPlaceholder
    ready={!isLoading}
    customPlaceholder={<FeaturePlaceholder />}
  >
    <div
      className={`product-options row border-color-ui-3 pt-2 pb-1 px-3 mx-0 ${
        !isVoucher === true ? 'd-block' : 'd-none'
      }`}
    >
      {Object.keys(features)
        .sort()
        .map(key => (
          <FeatureContainer
            key={key}
            type={key}
            items={features[key]}
            relationSkus={featuresSkusByCurrentSku}
            changeSku={changeSku}
            SkuByType={SkuByType}
          />
        ))}
    </div>
  </ReactPlaceholder>
)

Feature.propTypes = {
  isLoading: PropTypes.bool,
  isVoucher: PropTypes.bool,
  features: PropTypes.object,
  featuresSkusByCurrentSku: PropTypes.object,
  SkuByType: PropTypes.array,
  changeSku: PropTypes.func
}

export default Feature



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/Feature.js